import { Box, Heading, Divider } from 'native-base'
import React, { useEffect, useState } from 'react'
import { Text, View, Platform } from 'react-native'
import LottieView from 'lottie-react-native'
import styled from 'styled-components'
import UserPhoto from './UserPhoto'
import { userState } from '../state/atoms'
import { useRecoilValue } from 'recoil'
import { Octicons } from '@expo/vector-icons'
import { MaterialCommunityIcons } from '@expo/vector-icons'
import { FontAwesome5 } from '@expo/vector-icons'
import { doc, onSnapshot } from 'firebase/firestore'
import { db, auth } from '../firebase'

const ProfileContainer = styled(View)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

const UserSection = styled(View)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 30px 0;
`

const BoldText = styled(Heading)`
    font-size: 20px;
    font-weight: bold;
    margin: 0;
`

const MinorText = styled(Text)`
    font-size: 14px;
    color: gray;
    margin: 0;
`

const Bio = styled(Text)`
    margin: 20px;
    text-align: center;
    color: gray;
    font-size: 18px;
`

const Stats = styled(View)`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: space-between;
    justify-content: center;
`

const StatNumber = styled(BoldText)`
    font-size: 40px;
    padding-top: 10px;
`

const StatsBox = styled(Box)`
    width: 100px;
    height: 100px;
    margin: 0 20px;
    align-items: center;
    justify-content: center;
`

const ProfileCard = () => {
    const userData = useRecoilValue(userState)
    const [homesTagged, setHomesTagged] = useState(0)

    useEffect(() => {
        const unsubscribe = onSnapshot(doc(db, 'users', auth.currentUser.uid), (doc) => {
            setHomesTagged(doc.data().stats?.homes_tagged)
        })
        return () => {
            unsubscribe()
        }
    }, [])

    return (
        <ProfileContainer>
            <UserSection>
                {Platform.OS !== 'web' && (
                    <LottieView
                        source={require('../assets/animations/circles.json')}
                        autoPlay
                        loop
                        style={{
                            width: 150,
                            height: 150,
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <UserPhoto size={'xl'} image={userData?.user_photo} />
                    </LottieView>
                )}
                <BoldText>
                    {userData?.first_name} {userData?.last_name}
                </BoldText>
                <Heading size="2xl" color="#6c387a">
                    {userData?.username}
                </Heading>
                {userData?.location?.city && (
                    <MinorText>
                        {userData?.location?.city}, {userData?.location?.state}
                    </MinorText>
                )}
                {userData?.bio && <Bio>{userData?.bio}</Bio>}
            </UserSection>
            <Stats>
                <StatsBox>
                    <FontAwesome5 name="medal" size={24} color="#6c387a" style={{ marginBottom: 10 }} />
                    <StatNumber>{userData?.stats?.level}</StatNumber>
                    <MinorText>User level</MinorText>
                </StatsBox>
                <Divider orientation="vertical" />
                <StatsBox>
                    <MaterialCommunityIcons name="home-group" size={24} color="#6c387a" style={{ marginBottom: 10 }} />
                    <StatNumber>{homesTagged}</StatNumber>
                    <MinorText>Homes tagged</MinorText>
                </StatsBox>
                <Divider orientation="vertical" />
                <StatsBox>
                    <Octicons name="number" size={24} color="#6c387a" style={{ marginBottom: 10 }} />
                    <StatNumber>{userData?.stats?.points}</StatNumber>
                    <MinorText>Points</MinorText>
                </StatsBox>
            </Stats>
        </ProfileContainer>
    )
}

export default ProfileCard
